import { render } from "./ArrowRightIcon16.vue.js?vue&type=template&id=62cef4f2!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./ArrowRightIcon16.vue?vue&type=template&id=62cef4f2"
const script = {}

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__